import React, { useEffect, useState } from 'react'
import { Table, Input, Row, Col, DatePicker, Button, Form } from 'antd'
import { FileTextOutlined, SearchOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'

import axiosInstance from '../../Utils/axiosInstance'
import { GetFeeCollection } from "../../API's/AdminApi"
import { toast } from 'react-toastify'

const { RangePicker } = DatePicker

export default function FeeCollection() {
  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [tableLoading, setTableLoading] = useState(false)

  // DEFAULT DATE
  const [dateRange, setDateRange] = useState([
    dayjs().startOf('month'), // FROM DATE
    dayjs(), // TO DATE = CURRENT DATE
  ])

  // ---------------- GET DATA ----------------
  const getFeeCollection = async () => {
    try {
      setTableLoading(true)

      const fromDate = dateRange[0]?.format('YYYY-MM-DD')
      const toDate = dateRange[1]?.format('YYYY-MM-DD')

      const res = await axiosInstance.get(
        `${GetFeeCollection}?fromDate=${fromDate}&toDate=${toDate}`,
      )

      setData(res.data || [])
    } catch (error) {
      toast.error('Failed to load fee collection')
    } finally {
      setTableLoading(false)
    }
  }

  // FIRST TIME LOAD
  useEffect(() => {
    getFeeCollection()
  }, [])

  // ---------------- FORMAT DATE ----------------
  const formatDate = (date) => {
    if (!date) return '-'

    return new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  }

  // ---------------- TABLE ----------------
  const columns = [
    {
      title: 'Sr No',
      render: (_, __, index) => index + 1,
    },

    {
      title: 'Fee Name',
      dataIndex: 'feeName',
    },
    {
      title: 'Fee Amount',
      dataIndex: 'feeAmount',
    },
  ]

  // ---------------- SEARCH ----------------
  const filteredData = data.filter((item) =>
    item?.feeName?.toLowerCase().includes(searchText.toLowerCase()),
  )

  // ---------------- TOTAL AMOUNT ----------------
  const totalAmount = filteredData.reduce(
    (sum, item) => sum + Number(item.feeAmount || 0),
    0,
  )

  return (
    <div className="p-4 page-background">
      {/* HEADER */}
      <div className="page-header">
        <h2>
          <FileTextOutlined style={{ marginRight: 8 }} />
          Fee Collection
        </h2>
      </div>

      {/* FILTERS */}
      <Form layout="vertical">
        <Row gutter={[16, 16]} className="pb-2 m-0 align-items-end">
          {/* FROM DATE */}
          <Col xs={24} sm={12} md={6}>
            <Form.Item label="From Date" className="mb-0">
              <DatePicker size='large'
                style={{ width: '100%' }}
                format="DD/MM/YYYY"
                value={dateRange[0]}
                onChange={(date) => setDateRange([date, dateRange[1]])}
              />
            </Form.Item>
          </Col>

          {/* TO DATE */}
          <Col xs={24} sm={12} md={6}>
            <Form.Item label="To Date" className="mb-0">
              <DatePicker size='large'
                style={{ width: '100%' }}
                format="DD/MM/YYYY"
                value={dateRange[1]}
                onChange={(date) => setDateRange([dateRange[0], date])}
              />
            </Form.Item>
          </Col>

          {/* SEARCH BUTTON */}
          <Col xs={24} sm={12} md={4}>
            <Form.Item className="mb-0">
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={getFeeCollection}
                block
                style={{
                  height: 40,
                  fontWeight: 600,
                }}
              >
                Search
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Row gutter={16} className="pb-2 mt-3 m-0">
        <Col xs={24} md={12} xl={16}></Col>
        <Col xs={24} md={12} xl={8} className="pt-2 pt-md-0">
          <Input
            placeholder="Search Fee Name"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ height: 40 }}
          />
        </Col>
      </Row>

      {/* TOTAL AMOUNT
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: 16,
        }}
      >
        <div
          style={{
            background: '#f0f5ff',
            border: '1px solid #adc6ff',
            padding: '10px 18px',
            borderRadius: 8,
            fontSize: 16,
            fontWeight: 600,
            color: '#1d39c4',
          }}
        >
          Total Collection: ₹{totalAmount}
        </div>
      </div> */}

      {/* TABLE */}
      <Table
        className="custom-table-header shadow"
        columns={columns}
        dataSource={filteredData}
        rowKey="id"
        bordered
        loading={tableLoading}
        style={{ overflowX: 'auto', backgroundColor: 'white' }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '50'],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
      />
    </div>
  )
}
